import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';

import { Interval } from '@zapier/design-system-revenue/src/types';

import { professionalTrialEndedBanner_currentPlanQuery as CurrentPlanQuery } from './types/professionalTrialEndedBanner_currentPlanQuery';
import { professionalTrialEndedBanner_nextPlanQuery as NextPlanQuery } from './types/professionalTrialEndedBanner_nextPlanQuery';

export const currentPlanQuery = gql`
  query professionalTrialEndedBanner_currentPlanQuery($accountId: Int!) {
    account(id: $accountId) {
      id
      plan: planV2 {
        id
        interval
        name
      }
    }
  }
`;

export const nextPlanQuery = gql`
  query professionalTrialEndedBanner_nextPlanQuery(
    $accountId: Int!
    $currentPlanId: Int!
  ) {
    nextPlan(accountId: $accountId, currentPlanId: $currentPlanId) {
      amount
      id
      name
    }
  }
`;

export const useData = () => {
  const accountId = localStorage.getItem('currentAccountId');

  const {
    data: currentPlanData,
    loading: isLoadingCurrentPlan,
    error: currentPlanError,
  } = useQuery<CurrentPlanQuery>(currentPlanQuery, {
    skip: !accountId,
    variables: {
      accountId: accountId ? parseInt(accountId) : undefined,
    },
  });

  const currentPlanId = currentPlanData?.account?.plan?.id;

  const {
    data: nextPlanData,
    loading: isLoadingNextPlan,
    error: nextPlanError,
  } = useQuery<NextPlanQuery>(nextPlanQuery, {
    skip: !currentPlanId,
    variables: {
      accountId: accountId ? parseInt(accountId) : undefined,
      currentPlanId: currentPlanId ? parseInt(currentPlanId) : undefined,
    },
  });

  return {
    currentPlanName: currentPlanData?.account?.plan?.name ?? '',
    error:
      currentPlanError || nextPlanError
        ? 'There was an error fetching account information. Please try again.'
        : null,
    isLoading: isLoadingCurrentPlan || isLoadingNextPlan,
    nextPlanAmount: nextPlanData?.nextPlan?.amount ?? 0,
    nextPlanInterval:
      currentPlanData?.account?.plan?.interval ?? ('year' as Interval),
    nextPlanName: nextPlanData?.nextPlan?.name ?? '',
  };
};
